import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AnpReportData, AnpReportResponse } from "../types/anpReports.type";

type UseAnpHistoricalReportParams = {
  id?: string;
};

type UseAnpHistoricalReport = (params: UseAnpHistoricalReportParams) => UseQueryResult<AnpReportData, unknown>;

const useAnpHistoricalReport: UseAnpHistoricalReport = ({ id }) => {
  const privateAxios = usePrivateAxios();

  return useQuery<AnpReportResponse, unknown, AnpReportData>({
    enabled: !!id,
    queryKey: ['anpHistoricalReport', id],
    queryFn: () => privateAxios.get(`/anp/historical_reports/${id}`),
    select: (response) => response?.data?.data,
  });
};

export default useAnpHistoricalReport;
